export const TIMEPICKER = {
  "Timepicker.Selected.Color": {
    ref: "Color.Primary.500"
  },
  "Timepicker.Selected.Bg.Color": {
    ref: "Color.White"
  },
  "Timepicker.Selected.Border.Color": {
    ref: "Color.Primary.500"
  },
  "Timepicker.Bg.Color": {
    ref: "Color.Gray.100"
  },
  "Timepicker.Font.Size": {
    ref: "Input.Font.Size"
  },
  "Timepicker.Color": {
    ref: "Input.Color"
  },
  "Timepicker.Hover.Bg.Color": {
    ref: "Color.Gray.300"
  },
  "Timepicker.Hover.Color": {
    ref: "Color.Gray.800"
  }
};
